import {
  Box,
  SkeletonGroup,
  SkeletonLine,
  SkeletonRectangle,
} from '@wix/design-system';
import { useContext } from 'react';

import { Context } from '../../../context';

import css from './index.module.scss';

export const SkeletonLoading = () => {
  const { isMobile } = useContext(Context);

  return (
    <SkeletonGroup>
      <Box direction="vertical" gap="5" marginBottom="18px">
        <SkeletonRectangle className={css.header} />
        <Box direction="vertical" gap="3">
          {[...Array(isMobile ? 5 : 4)].map((_, index) => (
            <Box direction="vertical" key={index} gap="4">
              <Box direction="vertical">
                <Box>
                  <SkeletonRectangle className={css.articleTag} />
                </Box>
                <Box direction="vertical" gap="13px">
                  <Box direction="vertical" gap="2">
                    <SkeletonLine className={css.articleTitle} />
                    {isMobile && <SkeletonLine className={css.articleTitle} />}
                  </Box>
                  <Box verticalAlign="middle">
                    <Box direction="vertical" gap="2" width="100%">
                      <Box verticalAlign="middle" gap="7">
                        <Box direction="vertical" gap="2" width="100%">
                          <SkeletonLine className={css.descriptionFirst} />
                          <SkeletonLine className={css.descriptionSecond} />
                        </Box>
                        {!isMobile && (
                          <Box>
                            <SkeletonRectangle className={css.timeToRead} />
                          </Box>
                        )}
                      </Box>
                      <Box verticalAlign="middle" gap="11px">
                        <SkeletonRectangle className={css.category} />
                        {isMobile && (
                          <SkeletonRectangle className={css.timeToRead} />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {index < (isMobile ? 4 : 3) && (
                <SkeletonRectangle className={css.separator} />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </SkeletonGroup>
  );
};
